var map = {
	"./banner.png": "ec24",
	"./bannerTara.png": "bd93",
	"./button.png": "675d",
	"./classicall.png": "9e92",
	"./logo.png": "cf05",
	"./logo_black.png": "36b4",
	"./luxall.png": "c925",
	"./more.png": "69f5",
	"./primeall.png": "a269",
	"./slide/classic.png": "c02d",
	"./slide/left.png": "3d7d",
	"./slide/lux.png": "8f62",
	"./slide/prime.png": "4e16",
	"./slide/right.png": "06a3",
	"./slide/special.png": "fac9",
	"./slide/terma.png": "0b58",
	"./social/face.png": "f0d9",
	"./social/inst.png": "7f19",
	"./social/ok.png": "4168",
	"./social/vk.png": "1599",
	"./social/youtube.png": "c3d8",
	"./special.png": "855c",
	"./specialall.png": "0f29",
	"./termaall.png": "75a2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";